/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualSaleDto } from '../../models/backend-actual-sale-dto';
import { BackendActualSaleRequestDto } from '../../models/backend-actual-sale-request-dto';

export interface MonitoringActualsSalesCreate$XWwwFormUrlencoded$Params {
  /**
   * ID сценария для фильтрации списка
   */
  scenario_id?: number;

  /**
   * Поиск по текстовым полям сущности
   */
  search?: string;
  body: BackendActualSaleRequestDto;
}

export function monitoringActualsSalesCreate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringActualsSalesCreate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendActualSaleDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsSalesCreate$XWwwFormUrlencoded.PATH, 'post');
  if (params) {
    rb.query('scenario_id', params.scenario_id, {});
    rb.query('search', params.search, {});
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendActualSaleDto>;
    }),
  );
}

monitoringActualsSalesCreate$XWwwFormUrlencoded.PATH = '/api/monitoring/actuals/sales/';
